/**
     * @desc 主持人控制参会设备麦克风。如 operatedMemberUid 和 operatedMemberDeviceId 传递空，表示操作全部参会设备
可能产生业务错误码：510001、510002、511001、511005、580002
     */

import * as SWR from 'swr';

import * as defs from '../../baseClass';
import * as Hooks from '../../../hooks';
import { PontCore } from '../../../pontCore';

export class Params {}

export const method = 'POST';

export function mutate(
  params = {},
  newValue = undefined,
  shouldRevalidate = true,
) {
  return SWR.mutate(
    Hooks.getUrlKey('/api/bs-vmeeting/v3/meeting/control/mike', params, 'POST'),
    newValue,
    shouldRevalidate,
  );
}

export function useDeprecatedRequest(params = {}, swrOptions = {}) {
  return Hooks.useRequest(
    '/api/bs-vmeeting/v3/meeting/control/mike',
    params,
    swrOptions,
    { method: 'POST' },
  );
}

export function request(
  params: Params,
  body: defs.client.ModeratorOperatingEquipmentMicrophoneParameters,
  options?: any,
) {
  return PontCore.fetch(
    PontCore.getUrl('/api/bs-vmeeting/v3/meeting/control/mike', params, 'POST'),
    {
      method: 'POST',

      body,
      ...options,
    },
  );
}
